import dynamic from 'next/dynamic';

export const Radio = dynamic(
  () => import('antd/lib/radio'),
  { ssr: false },
);

export const RadioGroup = dynamic(
  () => import('antd/lib/radio/group'),
  { ssr: false },
);

export const RadioButton = dynamic(
  () => import('antd/lib/radio/radioButton'),
  { ssr: false },
);
